
export class PokerGlobalData {
    private static _instance: PokerGlobalData;

    public firstVisit: boolean = false;

    constructor() {
    }

    public static get instance(): PokerGlobalData {
        if (PokerGlobalData._instance == null) {
            PokerGlobalData._instance = new PokerGlobalData();
        }
        return PokerGlobalData._instance;
    }
}
